/**
 * @generated SignedSource<<adca6a9b2c643f9ebdeac22feb34edee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgStoresMapActiveUsers_organisation$data = {
  readonly recentlyActiveUsers: ReadonlyArray<{
    readonly id: string;
    readonly store: {
      readonly name: string;
    };
    readonly user: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"Avatar_user">;
    };
  }>;
  readonly " $fragmentType": "OrgStoresMapActiveUsers_organisation";
};
export type OrgStoresMapActiveUsers_organisation$key = {
  readonly " $data"?: OrgStoresMapActiveUsers_organisation$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgStoresMapActiveUsers_organisation">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgStoresMapActiveUsers_organisation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RecentlyActiveUser",
      "kind": "LinkedField",
      "name": "recentlyActiveUsers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Avatar_user"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "store",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organisation",
  "abstractKey": null
};
})();

(node as any).hash = "b006ba57dc7ff0f6ea950abc79d029ce";

export default node;
